module.exports = __webpack_public_path__ + "static/img/exercise-2.f6e0535.png";


//////////////////
// WEBPACK FOOTER
// ./static/website/images/exercise-2.png
// module id = tBSJ
// module chunks = 1